// extracted by mini-css-extract-plugin
export var leftAlign = "_n-2";
export var popper = "_n-0";
export var subtitle = "_n-1";